import { render, staticRenderFns } from "./editar-pessoa-deficiente-visual.vue?vue&type=template&id=02a725e3&"
import script from "./editar-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./editar-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a725e3')) {
      api.createRecord('02a725e3', component.options)
    } else {
      api.reload('02a725e3', component.options)
    }
    module.hot.accept("./editar-pessoa-deficiente-visual.vue?vue&type=template&id=02a725e3&", function () {
      api.rerender('02a725e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/editar-pessoa-deficiente-visual.vue"
export default component.exports